
import { SET_HEADER_DATA } from "../actions/headerAction";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HEADER_DATA:
      return { ...state, data: action.payload, status: "success", error: null };
    default:
      return state;
  }
};

export default headerReducer;

